import React from "react";

import CustomColor from "./color/CustomColor";
import FixedColor from "./color/FixedColor";
import SmallCountdown from "./small/SmallCountdown";
import Background from "./background/Background";
import { DESIGN_STYLES } from "../../../../optics/components/drawers/settings/features/countdown/defaults";

const designComponents = {
  [DESIGN_STYLES.CUSTOM_COLOR]: CustomColor,
  [DESIGN_STYLES.FIXED_COLOR]: FixedColor,
  [DESIGN_STYLES.SMALL_COUNTDOWN]: SmallCountdown,
  [DESIGN_STYLES.BACKGROUND]: Background,
};

function Design({ data, isEditable, viewMode = "view" }) {
  const DesignComponent = designComponents[data.timerType];

  return (
    <DesignComponent data={data} isEditable={isEditable} viewMode={viewMode} />
  );
}

export default Design;
